import * as React from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
} from '@mui/material';
import { User } from '@ivymobi/orbit-core';
import { useEffect } from 'react';


export default function WechatCode(props) {
  const { search } = location
  const paramsString = search.substring(1)
  const searchParams = new URLSearchParams(paramsString)  
  const { login } = props;
  

  useEffect(() => {
    login({code:searchParams.get('code')});
  }, []);



  return (
    <Box></Box>
  );
}